import { Controller } from '@hotwired/stimulus';
import {
  subscribeCustomEvent,
  unsubscribeCustomEvent,
} from '@frontend/utils/events';

export default class extends Controller {
  static targets = ['notificationBox', 'flashMessage'];

  connect() {
    this.boundHandleShowNotification = this.handleShowNotification.bind(this);
    this.boundClearNotification = this.clearNotification.bind(this);

    subscribeCustomEvent('notification:show', this.boundHandleShowNotification);
    subscribeCustomEvent('notification:clear', this.boundClearNotification);
    this.closeTimeout = null;
    this.notificationBoxTarget.addEventListener(
      'click',
      this.clearNotification.bind(this)
    );
  }

  disconnect() {
    unsubscribeCustomEvent(
      'notification:show',
      this.boundHandleShowNotification
    );
    unsubscribeCustomEvent('notification:clear', this.boundClearNotification);
  }

  flashMessageTargetConnected(element) {
    const message = element.textContent;
    if (message.length > 0) {
      const type = element.dataset.notificationType;
      const timeoutInMs = element.dataset.timeoutInMs;
      this.showNotification(message, { timeoutInMs, type });
      element.remove();
    }
  }

  handleShowNotification(event) {
    const message = event.detail.message;
    const timeoutInMs = event.detail.timeoutInMs;
    const type = event.detail.type;

    this.showNotification(message, { timeoutInMs, type });
  }

  show({ params: { message } }) {
    this.showNotification(message);
  }

  showNotification(message, { timeoutInMs = 3000, type = 'default' } = {}) {
    this.notificationBoxTarget.dataset.notificationType = type;

    if (this.closeTimeout) this.clearNotification();
    this.notificationBoxTarget.innerHTML = message;
    this.notificationBoxTarget.hidden = false;
    this.closeTimeout = setTimeout(
      this.clearNotification.bind(this),
      timeoutInMs
    );
  }

  clearNotification() {
    clearTimeout(this.closeTimeout);
    this.notificationBoxTarget.hidden = true;
  }
}

export function showNotification(message, options = {}) {
  options.message = message;
  document.body.dispatchEvent(
    new CustomEvent('notification:show', { bubbles: true, detail: options })
  );
}

export function clearNotification() {
  document.body.dispatchEvent(
    new CustomEvent('notification:clear', { bubbles: true })
  );
}
